<template>
	<section class="GoogleTranslate" :class="{ active }">
		<a v-if="!active" href="javascript: void(0)" @click="onClickTranslate" class="button translate-button icon-g_translate"></a>
		<div v-show="active" id="google-translate" ref="translator"></div>
		<a v-if="active" href="javascript: void(0)" @click="onClickClose" class="button close-button icon-cancel"></a>
	</section>
</template>

<script>
	import { waitUntil } from '../common/libs/utils';
	export default {
		data() {
			return {
				active: false,
				inited: false
			};
		},
		methods: {
			async onClickClose() {
				this.active = false;
				const iframe = document.querySelector('body > .skiptranslate iframe');
				if (iframe) {
					const closeButton = iframe.contentWindow.document.querySelector('.goog-close-link');
					closeButton.click();
				}
			},

			async onClickTranslate() {
				if (this.inited) {
					this.active = true;
				} else {
					while (!window.google) {
						const script = document.createElement('script');
						script.setAttribute('src', 'https://translate.google.com/translate_a/element.js');
						script.setAttribute('type', 'text/javascript');
						document.head.append(script);
						await waitUntil(() => window.google?.translate?.TranslateElement);
					}
					this.inited = true;
					this.active = true;
					console.log(window.google.translate.TranslateElement);
					new window.google.translate.TranslateElement({ autoDisplay: false }, 'google-translate');
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.GoogleTranslate {
		position: absolute;
		top: 0;
		right: 0;
		height: 5rem;
		display: flex;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 1rem;

		.button {
			color: var(--clrTitle);
			display: flex;
			width: 3.2rem;
			height: 3.2rem;
			background-color: white;
			align-items: center;
			justify-content: center;
			border-radius: 3.2rem;
			font-size: 2rem;
			margin-left: 1rem;
			transition: all .2s;

			&:hover {
				background-color: white;
				color: var(--clrTheme);
			}
		}

		.translate-button {
			background-color: transparent;
			color: white;
		}

		.close-button {
			font-size: 1.4rem;
			width: 2.4rem;
			height: 2.4rem;
		}

		#google-translate {
			/deep/ .skiptranslate {
				line-height: 0;
				color: transparent;

				div {
					line-height: initial;

					select {
						padding: 0.5rem 1rem;
						border: none;
						border-radius: 0.5rem;
					}
				}

				& > :not(div) {
					display: none;
				}
			}
		}
	}
</style>

<style lang="scss">
	body {
		top: 0 !important;

		> .skiptranslate {
			display: none;
		}
	}
</style>
